<script setup lang="ts">
import { WidgetHeroBannerBackdrop } from '../illustration'
import type { THeroBannerBackdrop } from '../illustration'

// Shared hero shell: content on the left, illustration over an abstract backdrop on the right.
// "wide" heroes span the whole container, "column" heroes sit next to the page sidebar.
const props = withDefaults(
  defineProps<{
    width?: 'wide' | 'column'
    backdrop?: THeroBannerBackdrop
  }>(),
  {
    width: 'column',
    backdrop: 'tunduk'
  }
)

const slots = defineSlots<{
  default(): unknown
  illustration?(): unknown
}>()

const layoutClass = {
  wide: 'lg:grid-cols-[minmax(0,1fr)_25rem]',
  column: 'xl:grid-cols-[minmax(0,1fr)_25rem]'
}

// Wide heroes follow the slider height; column heroes keep room for the illustration
const contentClass = {
  wide: 'md:py-6',
  column: 'md:py-7'
}

const illustrationClass = {
  wide: 'py-8',
  column: 'min-h-[22rem]'
}

const visibleClass = {
  wide: 'lg:flex',
  column: 'xl:flex'
}
</script>

<template>
  <section class="relative overflow-hidden rounded-lg bg-blue-50 text-brand-gray md:rounded-2xl">
    <div v-if="slots.illustration" class="absolute inset-0 hidden" :class="visibleClass[props.width]">
      <WidgetHeroBannerBackdrop :variant="props.backdrop" />
    </div>
    <div class="relative grid h-full items-center" :class="slots.illustration && layoutClass[props.width]">
      <div
        class="relative z-10 flex flex-col items-start gap-3 px-4 py-5 sm:p-6 md:px-8 [&_h1]:leading-tight"
        :class="contentClass[props.width]"
      >
        <slot />
      </div>
      <div
        v-if="slots.illustration"
        class="relative hidden h-full items-center"
        :class="[visibleClass[props.width], illustrationClass[props.width]]"
      >
        <slot name="illustration" />
      </div>
    </div>
  </section>
</template>
